import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { getDeepgramVoiceById } from '../../../basic/deepgram/deepgram';
import { TruncatePipe } from '../../../basic/pipes/truncate.pipe';
import { PersonalityService } from '../../../core/personality/personality.service';
import { getResumeSourceColor, getResumeSourceName, Resume } from '../../../core/resume/resume';
import { ResumeService } from '../../../core/resume/resume.service';
import { SessionTemplateService } from '../../../core/session-template/session.template.service';
import { SessionService } from '../../../core/session/session.service';
import { EditResumeComponent } from '../edit-resume/edit-resume.component';
import { ViewResumeDetailsComponent } from '../view-resume-details/view-resume-details.component';

@Component({
  selector: 'app-resume-list-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,
    NzTagModule,
    NzTabsModule,

    TruncatePipe,

    MatTooltip,

    ViewResumeDetailsComponent,
    EditResumeComponent,
  ],
  templateUrl: './resume-list-table.component.html',
  styleUrl: './resume-list-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResumeListTableComponent {
  @Input() resumeList: Resume[] = [];

  resumeChanged = toSignal(this.resumeService.resumeChanged$, { initialValue: 0 });

  constructor(
    private sessionService: SessionService,
    private resumeService: ResumeService,
    private sessionTemplateService: SessionTemplateService,
    private messageService: NzMessageService,
    private personalityService: PersonalityService,
    private router: Router
  ) {}

  getResumeSourceName(resume: Resume) {
    return getResumeSourceName(resume);
  }

  getResumeSourceColor(resume: Resume) {
    return getResumeSourceColor(resume);
  }

  getDeepgramVoiceById(resume: Resume) {
    return getDeepgramVoiceById(resume?.subData.content?.voice);
  }

  selectedPersonalityList = (resume: Resume) =>
    computed(() => {
      this.resumeChanged();

      return this.resumeService.getPersonalityList(resume)();
    });

  onViewResumeDetailsVisibleChange(isVisible: boolean) {
    if (isVisible === false) {
      this.showDetailsResume = undefined;
    }
  }

  showDetailsResume?: Resume;
  isViewResumeDetailsVisible = false;
  isEditResumeVisible = false;
  onViewDetailsClick(resume: Resume) {
    this.showDetailsResume = resume;
    this.isViewResumeDetailsVisible = true;
  }

  onEditProfileClick(resume: Resume) {
    this.showDetailsResume = resume;
    this.isEditResumeVisible = true;
  }

  onCopyProfileClick(resume: Resume) {
    this.resumeService
      .addResume$({ ...resume!.subData }, resume.type)
      .pipe(take(1))
      .subscribe(() => {});
  }
}
